export function generateProposalNumber() {
    const agora = new Date();

    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, "0");
    const dia = String(agora.getDate()).padStart(2, "0");
    const hora = String(agora.getHours()).padStart(2, "0");
    const minuto = String(agora.getMinutes()).padStart(2, "0");

    // número aleatório de 100 a 999
    const aleatorio = Math.floor(100 + Math.random() * 900);

    return `WEB-${ano}${mes}${dia}-${hora}${minuto}-${aleatorio}`;
}